<template>
  <div>
    <template v-if="props.pager?.items">
      <p v-if="props.pager.items.length === 0" class="p-4 text-secondary/60 text-sm text-center">
        {{ props.pager.loading ? `${ $t('general.loading') } ...` : empty }}
      </p>
      <div v-else>
        <slot :items="props.pager.visibleItems" />

        <div class="text-center mt-6">
          <p class="text-xs text-secondary/70 mb-3">{{ $t('pages.customer.index.showingCountOfTotal', {count: props.pager.visibleItems.length, total: props.pager.total}) }}</p>

          <b-button
            v-if="props.pager.hasMore"
            variant="action"
            size="sm"
            :loading="props.pager.loading"
            @click="props.pager.loadMore()"
          >
            {{ $t('general.showMore') }}
          </b-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type Pager from '~/utils/pager';

interface Props {
  pager: Pager<any>
  empty?: string
}

const props = withDefaults(defineProps<Props>(), {
  empty: 'No items to show...'
})
</script>